import React from 'react';
import { Row, Col, Container } from 'reactstrap';
import { connect } from 'react-redux';
import * as MaterialUI from 'material-ui';
import { Map, List } from 'immutable';
import moment from 'moment';

import { Field, reduxForm, formValueSelector, FieldArray } from 'redux-form/immutable';
import { FORM_PARADA } from 'modules/forms/formConstants';
import { TextFieldF, AutoCompleteF, TimePickerF, ToggleFieldF } from 'modules/forms/component';
import * as validations from 'modules/forms/validations';

const selector = formValueSelector(FORM_PARADA);
import { GMapsC } from 'modules/general/component';
import * as paradasActions from 'modules/paradas/action';
import * as generalActions from 'modules/general/action';
import { CancelarButtonC } from 'modules/general/component';
import { checkPermissions } from 'core/generalFunctions';
import * as trayectosActions from 'modules/trayectos/action';

class Add extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.routerWillLeave = this.routerWillLeave.bind(this);
  }
  routerWillLeave() {
    if (!this.props.pristine && !this.props.submitSucceeded) return 'El formulario tiene cambios,  ¿Está seguro de querer salir?';
  }
  componentDidMount() {
    this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave);
    const {
      dispatch,
      parada,
      params: { paradaId },
    } = this.props;
    this.props.trayectos.size == 0 && this.props.dispatch(trayectosActions.get());
    if (parada && !parada.get('nombre') && parada.get('localizacion')) this.props.dispatch(generalActions.reverseGeocoding(parada.get('localizacion').toJS(), FORM_PARADA, 'nombre'));
    if (paradaId === 'new') dispatch(generalActions.dashboard_changeTitle('AGREGAR PARADA'));
    else {
      dispatch(generalActions.dashboard_changeTitle('MODIFICAR PARADA'));
      dispatch(paradasActions.getById(paradaId));
    }
  }
  componentWillUnmount = () => this.props.dispatch(paradasActions.clear('parada'));
  submitForm = (data) => {
    const dataClon = formatData(data.toJS());
    delete dataClon.trayectoParadas;

    if (data.get('creadaByChofer')) {
      return this.props.dispatch(paradasActions.setSugerida(dataClon));
    }
    this.props.dispatch(paradasActions.set(dataClon, this.props.params.paradaId));
  };
  submitAndCreate = (data) => {
    data = formatData(data.toJS());
    delete data.trayectoParadas;
    this.props.dispatch(paradasActions.set(data, this.props.params.paradaId, true));
  };
  click = (e) => {
    if (e && e.latLng && e.latLng.lat && e.latLng.lng) {
      const lat = e.latLng.lat(),
        lng = e.latLng.lng();
      this.props.change('localizacion', { lat, lng });
      this.props.change('nombre', '');
      this.props.dispatch(generalActions.reverseGeocoding({ lat, lng }, FORM_PARADA, 'nombre'));
    }
  };
  onPlacesChanged(places) {
    if (!places || !places[0]) return;
    let paradaName = places[0].name;
    if (places[0].vicinity) paradaName += ', ' + places[0].vicinity;

    if (places[0] && places[0].geometry) {
      this.props.change('localizacion', {
        lat: places[0].geometry.location.lat(),
        lng: places[0].geometry.location.lng(),
      });
      if (places && places[0] && places[0].address_components && places[0].address_components[0] && paradaName) this.props.change('nombre', paradaName.replace(',,', ','));
    }
  }
  render() {
    const { localizacion, invalid, pristine, parada } = this.props;
    const trayectos =
      this.props.trayectos.toJS &&
      this.props.trayectos
        .sortBy((t) => t.get('nombre'))
        .map((trayecto) => ({
          nombre: trayecto.get('subnombre') ? trayecto.get('nombre') + ' - ' + trayecto.get('subnombre') : trayecto.get('nombre'),
          id: trayecto.get('id'),
        }))
        .toJS();
    return (
      <Container fluid={true}>
        <form>
          <Row>
            <Col md={{ size: 12 }}>
              <MaterialUI.Paper zDepth={2} className="padding">
                <MaterialUI.Tabs>
                  <MaterialUI.Tab label="Datos">
                    <div className="p-lr-10">
                      <Field
                        name={'alias'}
                        component={TextFieldF}
                        inputProps={{
                          hintText: 'Alias',
                          floatingLabelText: 'Ingrese el alias',
                          className: 'capitalize',
                          fullWidth: true,
                          autoFocus: true,
                        }}
                        validate={[validations.minLength3, validations.maxLength50]}
                      />
                      <Field
                        name={'nombre'}
                        component={TextFieldF}
                        inputProps={{
                          hintText: 'Nombre',
                          disabled: true,
                          className: 'capitalize',
                          fullWidth: true,
                          autoFocus: true,
                        }}
                        validate={[validations.required, validations.minLength3]}
                      />
                      <Field name={'localizacion'} component={TextFieldF} inputProps={{ className: 'hidden' }} validate={validations.required} />
                    </div>
                  </MaterialUI.Tab>
                </MaterialUI.Tabs>
              </MaterialUI.Paper>
            </Col>
            <Col md="12">
              <MaterialUI.Paper zDepth={2} className="padding">
                <MaterialUI.Tabs>
                  <MaterialUI.Tab label="Localización">
                    <div style={{ height: 500, maxWidth: '100%' }}>
                      <GMapsC
                        searchBox={true}
                        onMapClick={this.click.bind(this)}
                        mapElement={<div style={{ height: '100%' }} />}
                        onPlacesChanged={this.onPlacesChanged.bind(this)}
                        containerElement={<div style={{ height: '100%' }} />}
                        ubicacionParada={localizacion ? (localizacion.toJS ? localizacion.toJS() : localizacion) : null}
                      />
                    </div>
                  </MaterialUI.Tab>
                </MaterialUI.Tabs>
              </MaterialUI.Paper>
            </Col>
            <Col md="12">
              <MaterialUI.RaisedButton
                onClick={this.props.handleSubmit(this.submitForm)}
                label="GUARDAR"
                primary={true}
                disabled={invalid || (pristine && !parada.get('creadaByChofer')) || !checkPermissions(['admin', 'devAdmin', 'administrador_paradas'])}
                className="fullWidthComponent noPadding m-tb-20"
              />
            </Col>
            <Col md="12">
              <MaterialUI.RaisedButton
                onClick={this.props.handleSubmit(this.submitAndCreate)}
                label="GUARDAR Y CREAR OTRA"
                primary={true}
                disabled={invalid || pristine || !checkPermissions(['admin', 'devAdmin', 'administrador_paradas']) || parada.get('creadaByChofer')}
                className="fullWidthComponent noPadding m-tb-20"
              />
            </Col>
          </Row>
        </form>
        {typeof this.props.isPopup === 'function' ? null : <CancelarButtonC className="m-tb-20" dispatch={this.props.dispatch} />}
      </Container>
    );
  }
}
const formatData = (data) => {
  let rutinas = [],
    trayectos = [],
    dataClon = Object.assign({}, data);

  if (data.creadaByChofer) delete dataClon.creadaByChofer;
  else {
    dataClon.id = dataClon.paradaId;
    delete dataClon.paradaId;
    if (data.rutinas) {
      Object.keys(data.rutinas).forEach((key) => data.rutinas[key] && rutinas.push(key));
      dataClon.rutinas = rutinas;
    }
    if (data.trayectos) {
      Object.keys(data.trayectos).forEach((key) => data.trayectos[key] && trayectos.push(key));
      dataClon.trayectos = trayectos;
    }
  }

  return dataClon;
};

Add = reduxForm({ form: FORM_PARADA, enableReinitialize: true })(Add);
Add = connect((store) => ({
  viajes: store.get('viajes'),
  parada: store.getIn(['paradas', 'parada']),
  localizacion: selector(store, 'localizacion') || null,
  trayectos: store.getIn(['trayectos', 'lista']),
  trayectoParadasBase: store.getIn(['paradas', 'parada', '_trayectoParadas']) || Map(),
  trayectosSeleccionados: (selector(store, 'trayectoParadas') || List()).map((t) => t.get('trayectoId')),
  initialValues: {
    alias: store.getIn(['paradas', 'parada', 'alias']),
    nombre: store.getIn(['paradas', 'parada', 'nombre']),
    localizacion: store.getIn(['paradas', 'parada', 'localizacion']),
    trayectoParadas: (store.getIn(['paradas', 'parada', '_trayectoParadas']) || []).filter((t) => t.get('horarioDesde')),
    creadaByChofer: store.getIn(['paradas', 'parada', 'creadaByChofer']),
    paradaId: store.getIn(['paradas', 'parada', 'id']),
  },
}))(Add);

export default Add;



// WEBPACK FOOTER //
// src/modules/paradas/components/add.js